import { render, staticRenderFns } from "./index copy改变彩色图标后(但是其他所有用到图标的地方都需要改为svg，还没改).vue?vue&type=template&id=aa415868&scoped=true"
import script from "./index copy改变彩色图标后(但是其他所有用到图标的地方都需要改为svg，还没改).vue?vue&type=script&lang=js"
export * from "./index copy改变彩色图标后(但是其他所有用到图标的地方都需要改为svg，还没改).vue?vue&type=script&lang=js"
import style0 from "./index copy改变彩色图标后(但是其他所有用到图标的地方都需要改为svg，还没改).vue?vue&type=style&index=0&id=aa415868&scoped=true&lang=css"
import style1 from "./index copy改变彩色图标后(但是其他所有用到图标的地方都需要改为svg，还没改).vue?vue&type=style&index=1&id=aa415868&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa415868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa415868')) {
      api.createRecord('aa415868', component.options)
    } else {
      api.reload('aa415868', component.options)
    }
    module.hot.accept("./index copy改变彩色图标后(但是其他所有用到图标的地方都需要改为svg，还没改).vue?vue&type=template&id=aa415868&scoped=true", function () {
      api.rerender('aa415868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulemanager/index copy改变彩色图标后(但是其他所有用到图标的地方都需要改为svg，还没改).vue"
export default component.exports